import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import cx from 'classnames';
import { ResponsiveFontSize } from './responsive-font-size';
import { Icon, IconNames } from '@components/icon';
export interface IAlphatarProps {
  firstName?: string;
  lastName?: string;
  shape: 'circle' | 'square';
}
export const Alphatar: React.FC<IAlphatarProps> = t0 => {
  const $ = _c(19);
  const {
    firstName,
    lastName,
    shape: t1
  } = t0;
  const shape = t1 === undefined ? "circle" : t1;
  let t2;
  if ($[0] !== firstName || $[1] !== lastName) {
    t2 = () => {
      if (firstName && lastName) {
        return firstName[0] + lastName[0];
      }
      if (firstName) {
        return firstName[0];
      }
      if (lastName) {
        return lastName[0];
      }
      return "?";
    };
    $[0] = firstName;
    $[1] = lastName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const displayName = t2;
  const t3 = shape === "circle";
  const t4 = shape === "square";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = cx("p-2 aspect-[1] w-full h-full border-[1.5px] border-primary-main rounded-full", {
      "rounded-full": t3,
      "rounded-2xl": t4
    });
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== firstName || $[7] !== lastName) {
    t6 = !firstName && !lastName && <Icon className="h-4/6 w-4/6 m-auto pb-0.5" name={IconNames.USER} />;
    $[6] = firstName;
    $[7] = lastName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== displayName || $[10] !== firstName || $[11] !== lastName) {
    t7 = (firstName || lastName) && <div className="h-2/3 w-full m-auto"><ResponsiveFontSize ratio={0.68}>{displayName()}</ResponsiveFontSize></div>;
    $[9] = displayName;
    $[10] = firstName;
    $[11] = lastName;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex flex-col h-full justify-center uppercase text-primary-main text-center">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};